export const CART_ACTION_TYPE = {
    FETCH_CART_ITEMS_START: "FETCH_CART_ITEMS_START",
    FETCH_CART_ITEMS_SUCCESS: "FETCH_CART_ITEMS_SUCCESS",
    FETCH_CART_ITEMS_FAILED: "FETCH_CART_ITEMS_FAILED",
    SET_CART_OPEN: "SET_CART_OPEN",
    SET_ORDER_PLACED: "SET_ORDER_PLACED",
    SET_CART_ITEMS: "SET_CART_ITEMS",
    UPDATE_CART_START: "UPDATE_CART_START",
    UPDATE_CART_SUCCESS: "UPDATE_CART_SUCCESS",
    UPDATE_CART_FAILED: "UPDATE_CART_FAILED",
}
